import { RUN_LOGOUT, RUN_LOGIN, RUN_STATE_LOAD, SET_INFO, SET_STATE, GET_TOKEN, RUN_FORGOT_PASSWORD, RUN_RESET_PASSWORD_FROM_HASH, RUN_CHANGE_PASSWORD, RUN_USER_LOGIN_2FA } from '../types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import * as types from '@/types'
import { Const } from '../plugins/registerSteps/provider/lib/const.cls'
const product = process.env.product;
export const actions = {
    [RUN_LOGIN]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_LOGIN, credentials, '', commit, (error, result) => {
            if (!error) {
                if (parseInt(result.res_data.user.profile.u2fa_flag) == 1) {
                    credentials.localParams.parameter.gAuthenticatorEnabled = true;
                    credentials.localParams.parameter.token = result.res_data.user.token;
                    credentials.localParams.parameter.isAutoLogin = false;
                } else {
                    result.res_data.user.loggedIn = true
                    commit(SET_STATE, result.res_data.user)
                    localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                    
                   /* if ((parseInt(result.res_data.user.lead_type) == 0 && parseInt(result.res_data.user.step) < 3) || (parseInt(result.res_data.user.lead_type) == 1 && parseInt(result.res_data.user.step) < 4)) {
                        credentials.localParams.parameter.$router.replace('/welcome')
                    } else {
                        credentials.localParams.parameter.$router.replace('/home')
                    }*/
                    // credentials.localParams.parameter.$router.replace('/home')
                    _messageDisplayFunction(credentials.localParams.parameter, 'login successfully', 'success')
                    // credentials.localParams.parameter.addUser();
                    if(product == 'act'){
                        credentials.localParams.parameter.saveUser(credentials.globalParams.email, credentials.globalParams.server_type, credentials.globalParams.password).then(() => {
                            // if(window.isMobileCheck)this.$router.replace('/grid-view');
                            location.reload();
                        }).catch((err) =>{
                            alert("Error adding user:", err);
                            location.reload();
                        });
                    }else{
                        location.reload();
                    }
                    // credentials.localParams.parameter.$parent.page_type == ''
                    
                }
            } else {
                credentials.localParams.parameter.isAutoLogin = false;
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_USER_LOGIN_2FA]({ commit, state, dispatch, getters }, credentials) {
        _executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials, '', commit, (error, result) => {
            if (!error) {
                result.res_data.user.loggedIn = true
                commit(SET_STATE, result.res_data.user)
                localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                /*if ((parseInt(result.res_data.user.lead_type) == 0 && parseInt(result.res_data.user.step) < 3) || (parseInt(result.res_data.user.lead_type) == 1 && parseInt(result.res_data.user.step) < 4)) {
                    credentials.localParams.parameter.$router.replace('/welcome')
                } else {
                    credentials.localParams.parameter.$router.replace('/home')
                }*/
                // credentials.localParams.parameter.$router.replace('/home')
                _messageDisplayFunction(credentials.localParams.parameter, 'login successfully', 'success')

                if(window.isMobileCheck) credentials.localParams.parameter.$router.replace('/grid-view');
                location.reload();
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_STATE_LOAD]({ commit, state, getters, dispatch }, credentials) {
        const data = {}
        let user = localStorage.getItem('user')
        if (user) {
            user = atob(user)
            user = JSON.parse(user)
        }
        commit(SET_STATE, user)
        if (user !== null && user !== '') {
            _executeApi(Enpoints.EP_FRESH_DATA, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
                if (!error) {
                    result.res_data.user.loggedIn = true
                    commit(SET_STATE, result.res_data.user)
                    localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                } else {
                    _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                }
            })
        }
    },
    [RUN_LOGOUT]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_LOGOUT, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                _handleLogout(result.res_data, commit, { router: credentials.localParams.parameter.$router, forward: true })

                _messageDisplayFunction(credentials.localParams.parameter, 'logout successfully', 'success')
                if(window.isMobileCheck) credentials.localParams.parameter.$router.replace('/');
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_FORGOT_PASSWORD]({ commit, state, getters, dispatch }, credentials) {
        _executeApi(Enpoints.EP_FORGOT_PASSWORD, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.resend = true
                _messageDisplayFunction(credentials.localParams.parameter, 'A link for change password has been sent on your registered email id', 'success')
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_RESET_PASSWORD_FROM_HASH]({ commit, state, dispatch, getters }, credentials) {
        _executeApi(Enpoints.EP_RESET_PASSWORD_FROM_HASH, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.displayMessage = true
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, "Sorry! This link has been exipred. Click <router-link :to='/forgot-password'>Here</router-link> to reset again!", 'error')
            }
        })
    },
    [RUN_CHANGE_PASSWORD]({ commit, state, getters }, credentials) {
        _executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.clearAll()
                _messageDisplayFunction(credentials.localParams.parameter, 'password changed successfully', 'success')
            } else {
                _messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })

    },
}

//================================functions======================================
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if (typeof data.msg == 'object') {
                                response_array.res_data = data.msg.msg
                            } else {
                                response_array.res_data = data.msg
                            }
                            callback(true, response_array)
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js